import React from "react";
import "./MobileDevelopment.css";
import SEO from "../../SEO";
const mobileServices = [
  {
    title: "Native Android Development",
    description:
      "We build high-performance native Android applications using Kotlin and Java. Native apps provide maximum performance, deep hardware integration, and full access to Android APIs, making them ideal for enterprise-grade and performance-critical applications.",
    features: [
      "Kotlin / Java",
      "High Performance",
      "Full Android API Access",
      "Play Store Deployment",
      "Secure Architecture",
    ],
    img: process.env.PUBLIC_URL + "/img/android.gif",
    icon: "bi-android2",
  },
  {
    title: "React Native Development",
    description:
      "React Native enables cross-platform mobile app development using a single JavaScript codebase. It allows faster development cycles while delivering near-native performance for Android and iOS applications.",
    features: [
      "Single Codebase",
      "iOS & Android",
      "Fast Development",
      "Reusable Components",
      "API Integration",
    ],
    img: process.env.PUBLIC_URL + "/img/react-native.gif",
    icon: "bi-phone",
  },
  {
    title: ".NET MAUI / Xamarin",
    description:
      "Using .NET MAUI and Xamarin, we develop enterprise-level cross-platform applications with C#. Ideal for businesses already using Microsoft technologies, offering strong backend integration and shared code across platforms.",
    features: [
      "C# Development",
      ".NET MAUI",
      "Enterprise Integration",
      "Cross-Platform",
      "Microsoft Ecosystem",
    ],
    img: process.env.PUBLIC_URL + "/img/maui.gif",
    icon: "bi-microsoft",
  },
  {
    title: "Flutter Development",
    description:
      "Flutter allows building beautiful, highly responsive applications using Dart with a single codebase. It offers fast UI rendering and consistent design across Android and iOS platforms.",
    features: [
      "Dart Language",
      "Single Codebase",
      "Custom UI Design",
      "High Performance Rendering",
      "Fast Development",
    ],
    img: process.env.PUBLIC_URL + "/img/flutter.gif",
    icon: "bi-phone-fill",
  },
  {
    title: "Hybrid Applications",
    description:
      "Hybrid mobile apps use web technologies like HTML, CSS, and JavaScript wrapped inside a native container. These are cost-effective solutions for startups and MVP development with faster deployment cycles.",
    features: [
      "HTML / CSS / JS",
      "Cost Effective",
      "Rapid MVP Development",
      "Cross-Platform",
      "WebView Based",
    ],
    img: process.env.PUBLIC_URL + "/img/hybrid.gif",
    icon: "bi-layers",
  },
];

function MobileDevelopment() {
  return (
    <>
      <SEO
        title="Mobile App Development – MZR Software"
        description="Build native and cross-platform mobile apps with MZR Software’s development expertise."
        image="https://mzrsoftware.com/assets/images/og-mobiledevelopment.jpg"
        url="https://mzrsoftware.com/OurServices/MobileDevelopment/mobiledevelopment"
      />

      <div className="mobile-development-page">
        <section className="services-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">
                MZR <span className="highlight">Mobile Development</span>
              </h2>
              <p className="section-subtitle">
                Building powerful Android & iOS applications using modern mobile
                technologies.
              </p>
            </div>

            <div className="services-grid">
              {mobileServices.map((service, index) => (
                <div
                  key={index}
                  className={`service-card zig-zag ${
                    index % 2 === 0 ? "left" : "right"
                  }`}
                >
                  <div className="card-content">
                    <span className={`bi ${service.icon} service-icon`}></span>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="service-features">
                      {service.features.map((feature, i) => (
                        <span key={i} className="feature-tag">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="card-image">
                    <img src={service.img} alt={service.title} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default MobileDevelopment;
